import { render, staticRenderFns } from "./KoltukSecimi.vue?vue&type=template&id=d1011264&"
import script from "./KoltukSecimi.vue?vue&type=script&lang=js&"
export * from "./KoltukSecimi.vue?vue&type=script&lang=js&"
import style0 from "./KoltukSecimi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports